/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the tag name
 *   * ALIAS : the tag alias
 *   * UNIT : the tag unit
 *   * LAST_VALUES_LAST_VALUE_DATETIME : the tag last value datetime
 *   * LAST_VALUES_LAST_VALUE : the tag last value
 *   * VALUE_TYPE : the tag value type
 *   * STATION_CODE : the station code
 */
export enum TagSortFieldName {
  NAME = 'NAME',
  ALIAS = 'ALIAS',
  UNIT = 'UNIT',
  LAST_VALUES_LAST_VALUE_DATETIME = 'LAST_VALUES_LAST_VALUE_DATETIME',
  LAST_VALUES_LAST_VALUE = 'LAST_VALUES_LAST_VALUE',
  VALUE_TYPE = 'VALUE_TYPE',
  STATION_CODE = 'STATION_CODE'
}
